import { mapActions, mapGetters, mapMutations } from "vuex"

export default {
  methods: {
    ...mapMutations({
      setUnShowHead: "userInfo/setUnShowHead",
      setNextRouteName: "userInfo/setNextRouteName",
      showOpenApp: "showOpenApp"
    }),
    ...mapActions({
      getUserInfoBindPhone: "userInfo/getUserInfoBindPhone",
      getUserDetail: "userInfo/getUserDetail"
    }),
    async handleJumpPage(routeName) {
      const isNfPlus = this.systemInfo.isNfPlus
      if (!isNfPlus) {
        this.showOpenApp("请打开南方+报名或查看我的申报")
        return
      } else {
        const hasUserInfo = await this.getUserInfoBindPhone()
        if (!hasUserInfo) return
        if (routeName === "contribute") {
          this._handleJumpContribute(routeName)
          return
        }
        hasUserInfo && this.$router.push({ name: routeName })
      }
    },
    async _handleJumpContribute(routeName) {
      let hasPerfectedUserInfo = this.hasPerfectedUserInfo
      if (!hasPerfectedUserInfo) {
        await this.getUserDetail()
        hasPerfectedUserInfo = this.hasPerfectedUserInfo
      }
      if (hasPerfectedUserInfo) {
        this.$router.push({ name: routeName })
      } else {
        this.setNextRouteName("contribute")
        this.setUnShowHead(true)
        this.$router.push({ name: "userInfo" })
      }
    }
  },
  computed: {
    ...mapGetters({
      systemInfo: "systemInfo",
      hasPerfectedUserInfo: "userInfo/hasPerfectedUserInfo"
    })
  }
}
